export type CanvasDatabaseSyncReason =
  | 'render-update'
  | 'row-count'
  | 'storage-ready'
  | 'transform-reentry';

export class CanvasDatabasePresentationScheduler {
  private frame: number | null = null;

  private readonly reasons = new Set<CanvasDatabaseSyncReason>();

  constructor(
    private readonly flush: (
      reasons: readonly CanvasDatabaseSyncReason[]
    ) => void,
    private readonly requestFrame: typeof requestAnimationFrame = callback =>
      globalThis.requestAnimationFrame(callback),
    private readonly cancelFrame: typeof cancelAnimationFrame = frame =>
      globalThis.cancelAnimationFrame(frame)
  ) {}

  dispose(): void {
    if (this.frame !== null) {
      this.cancelFrame(this.frame);
      this.frame = null;
    }
    this.reasons.clear();
  }

  queue(reason: CanvasDatabaseSyncReason): void {
    this.reasons.add(reason);
    if (this.frame !== null) {
      return;
    }
    this.frame = this.requestFrame(() => {
      this.frame = null;
      const reasons = [...this.reasons];
      this.reasons.clear();
      this.flush(reasons);
    });
  }
}
